import { Field, Label } from '@headlessui/react'
import DatePicker from 'react-date-picker'
import 'react-date-picker/dist/DatePicker.css'
import 'react-calendar/dist/Calendar.css'
import './DatePickerField.css'
import { useCallback, useState } from 'react'

interface IDatePickerFieldProps {
  label: string
  value?: Date | null
  onChange?: (value: Date | null) => void
}

type ValuePiece = Date | null
type Value = ValuePiece | [ValuePiece, ValuePiece]

export const DatePickerField = (props: IDatePickerFieldProps) => {
  // Uncontrolled fallback when no value prop is provided
  const [internalValue, setInternalValue] = useState<Value>(props.value ?? null)

  const handleChange = useCallback(
    (val: Value) => {
      // We only use single-date selection in this app
      const dateVal = Array.isArray(val) ? (val[0] as Date | null) : (val as Date | null)
      if (props.onChange) {
        props.onChange(dateVal)
      } else {
        setInternalValue(dateVal)
      }
    },
    [props.onChange],
  )

  const pickerValue: Value = props.value !== undefined ? props.value : internalValue

  return (
    <Field>
      <Label className={'text-lg'}>{props.label}</Label>
      <div className={'relative mt-3'}>
        <DatePicker
          className={'date-picker-field'}
          calendarIcon={null}
          clearIcon={null}
          value={pickerValue}
          onChange={handleChange}
          format={'y / M / d'}
        />
      </div>
    </Field>
  )
}
